import { createFileRoute } from '@tanstack/react-router'
import { transferPrintSearchSchema } from '../../../../features/inventory/search'
import { StockTransferPrintPage } from '../../../../features/inventory/stock-transfer-print-page'

export const Route = createFileRoute('/_app/stock-transfers/$transferId/print')({
  staticData: { crumb: 'stockTransferPrint' },
  validateSearch: transferPrintSearchSchema,
  component: StockTransferPrintPage,
})
